// libraries.
import { Modal, Form, Button, Spinner } from "react-bootstrap";
import { electricPurple500, monserratSemiBold } from "@habitech/shared";

// interfaces.
import { IncentiveStep } from "../../rulesData";

// hook.
import { useEditStepForm } from "./useEditStepForm";

// components.
import { EditStepFields } from "./EditStepFields";

interface Props {
  step: IncentiveStep | null;
  country: string;
  onClose: () => void;
}

export const EditStepModal = ({ step, country, onClose }: Props) => {
  const { methods, dayRangeFrom, onSubmit, isSaving } = useEditStepForm({
    step,
    country,
    onClose,
  });

  return (
    <Modal show={step !== null} onHide={onClose} centered size="lg">
      <Modal.Header
        closeButton
        style={{ borderBottom: `2px solid ${electricPurple500}` }}
      >
        <Modal.Title
          style={{ fontFamily: monserratSemiBold, fontWeight: 600, fontSize: 16 }}
        >
          Editar paso de incentivo
        </Modal.Title>
      </Modal.Header>

      <Form onSubmit={onSubmit}>
        <Modal.Body>
          <EditStepFields
            register={methods.register}
            errors={methods.formState.errors}
            dayRangeFrom={dayRangeFrom}
          />
        </Modal.Body>

        <Modal.Footer style={{ borderTop: "1px solid #eee" }}>
          <Button
            className="btn-habi-white"
            onClick={onClose}
            disabled={isSaving}
          >
            Cancelar
          </Button>
          <Button type="submit" className="btn-habi" disabled={isSaving}>
            {isSaving ? <Spinner size="sm" animation="border" /> : "Guardar cambios"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

